import {
  RECEIVE_BANNERS,
  FETCH_BANNERS,
  SET_BANNERS_ERRORS,
  RECEIVE_BANNERS_CODES,
  FETCH_BANNERS_CODES,
} from '../constants';
import { createReducer } from '../utils/misc';

const initialState = {
    errors: {},
    fetching: {},
    banners: {},
    bannersCodes: {},
};

export default createReducer(initialState, {
  [RECEIVE_BANNERS]: (state, payload) => {
    const { bannerCode, bannerValue } = payload;
    const newFetching = { ...state.fetching };
    const newErrors = { ...state.errors };
    delete newFetching[bannerCode];
    delete newErrors[bannerCode];
    return {
      ...state,
      banners: { ...state.banners, [bannerCode]: bannerValue },
      fetching: newFetching,
      errors: newErrors,
    };
  },
  [FETCH_BANNERS]: (state, payload) => {
    const { bannerCode } = payload;
    const newErrors = { ...state.errors };
    delete newErrors[bannerCode];
    return {
      ...state,
      fetching: { ...state.fetching, [bannerCode]: true },
      errors: newErrors,
    };
  },
  [SET_BANNERS_ERRORS]: (state, payload) => {
    const { bannerCode, bannerError } = payload;
    const newFetching = { ...state.fetching };
    delete newFetching[bannerCode];
    return {
      ...state,
      errors: { ...state.errors, [bannerCode]: bannerError },
      fetching: newFetching,
      banners: { ...state.banners },
    };
  },

  [FETCH_BANNERS_CODES]: (state, payload) => {
    const { variableName } = payload;
    const newErrors = { ...state.errors };
    delete newErrors[variableName];
    return {
      ...state,
      fetching: { ...state.fetching, [variableName]: true },
      errors: newErrors,
    };
  },
  [RECEIVE_BANNERS_CODES]: (state, payload) => {
    const { bannerCode, bannersCodes } = payload;
    const newFetching = { ...state.fetching };
    const newErrors = { ...state.errors };
    
    delete newFetching[bannerCode];
    delete newErrors[bannerCode];

    return {
      ...state,
      bannersCodes: { ...state.bannersCodes, [bannerCode]: bannersCodes },
      fetching: newFetching,
      errors: newErrors,
    };
  }
});